import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	// Actions
	copyTooltipHover: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	copyTooltipFeedback: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	// Actions
	copyTooltipHover: {
		defaultMessage: 'Copy {itemToCopy}',
		id: 'applinks.administration.ui.common.fields.copy-button.copy-tooltip-hover',
		description: 'Tooltip shown on hover, informs user that clicking will copy content',
	},
	copyTooltipFeedback: {
		defaultMessage: 'Copied',
		id: 'applinks.administration.ui.common.fields.copy-button.copy-tooltip-feedback',
		description: 'Feedback message shown in tooltip after content is copied',
	},
});
export default messages;
